module.exports = __webpack_public_path__ + "static/media/pic_simon.31f69a99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic_simon.jpg
// module id = 59
// module chunks = 0